import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	convertProvinceIdToObject,
	formatDate,
	formatDateToShow,
	useNavigateToLogout,
} from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CountryService } from "../../services/common/CountryService";
import { DDLDataTable } from "../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { IMinimumWageRate } from "../../models/MinimumWageRate/IMinimumWageRate";
import { MinimumWageRateInfoSetupFieldsPanel } from "./Panels/MinimumWageRateInfoSetupFieldsPanel";
import { MinimumWageRateService } from "../../services/MinimumWageRateService";
import { MinimumWageRateSetupToolbar } from "./MinimumWageRateSetupToolbar/MinimumWageRateSetupToolbar";
import { MinimumWageRateSetupValidationSchema } from "./validator";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";








export interface IMinimumWageRateSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "minimumWageRate-single-data-record";
const DEPARTMENTS_LIST_DATA_QUERY_KEY = "minimumWageRate-list";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return MinimumWageRateService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useMinimumWageRate = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return MinimumWageRateService.getMinimumWageRate(
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});
export const MinimumWageRateSetup: React.FC<IMinimumWageRateSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [minimumWageRateId, setMinimumWageRateId] = useState<number | string>(
		0
	);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceDDLItems, setProvinceDDLItems] = useState<any>(undefined);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "minWageRate",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "minWageRate",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useMinimumWageRate(queryParams, navigateToLogout);

	const minimumWageRateList: any | null = data;

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	const { isPending: isSubmitting, mutate: submitMinimumWageRateFormFields } =
		useMutation({
			mutationFn: MinimumWageRateService.create,
			onSuccess: (res: IMinimumWageRate | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIMinimumWageRateResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/minimum-wage-rate/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIMinimumWageRateResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/minimum-wage-rate/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout
	);

	const upadtedMinimumWageRateListItems = useMemo(() => {
		return (
			minimumWageRateList &&
			minimumWageRateList.items &&
			minimumWageRateList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/minimum-wage-rate/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{/* {item.minWageRate} */}
						{formatDateToShow(item.dateEffective)}
					</Link>
				),
				// dateEffective:
				// 	item.dateEffective !== "" && formatDateToShow(item.dateEffective),
			}))
		);
	}, [minimumWageRateList]);

	const DEFAULT_VALUES = {
		province: undefined,
		minWageRate: undefined,
		dateEffective: null,
		type: undefined,

	};
	const formMethods = useForm<any>({
		resolver: yupResolver(MinimumWageRateSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {

		// const selectedProvinceOrState = values.province
		// 	? provinceDDLItems.find((e: any) => e.value === values.province)
		// 	: values.state
		// 	? provinceDDLItems.find((e: any) => e.value === values.province)
		// 	: undefined;
		// const selectedProvinceObject = convertProvinceIdToObject([values.province])
		const regenrateProvinceDDLItems = provinceDDLItems.map(({ label, value, shortCode }: any) => ({
			name: label,
			id: value,
			shortCode,
		}));


		const selectedProvinceArrayOfObjects = regenrateProvinceDDLItems.find(
			(item: any) => values.province === item.id
		);
		let payload = {
			id: id && id,
			navigateToLogout: navigateToLogout,
			// province: {
			// 	name: selectedProvinceOrState.label,
			// 	value: selectedProvinceOrState.value,
			// 	shortCode: selectedProvinceOrState.shortCode,
			// },
			// province: Array.isArray(selectedProvinceObject) ? selectedProvinceObject : values.province,
			// province: values.province && convertProvinceIdToObject(values.province,navigateToLogout),
			province: selectedProvinceArrayOfObjects,
			minWageRate: values.minWageRate,
			dateEffective: values.dateEffective && formatDate(values.dateEffective),
			type: values.type,
		};
		submitMinimumWageRateFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "dateEffective") {
					let date = new Date(fieldValue);

					formMethods.setValue(fieldName, date ?? undefined);
				}
				if (fieldName === "province") {
					formMethods.setValue(fieldName, fieldValue.id ?? undefined);
				}
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteMinimumWageRateById } =
		useMutation({
			mutationFn: MinimumWageRateService.delMinimumWageRate,
			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the MinimumWageRate fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				formMethods.reset();
				let path = `/minimum-wage-rate`;
				navigate(path);
				return queryClient.invalidateQueries({
					queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
				});
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const deleteMinimumWageRateField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				minimumWageRateId: minimumWageRateId,
				navigateToLogout: navigateToLogout,
			};
			deleteMinimumWageRateById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setMinimumWageRateId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setMinimumWageRateId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveMinimumWageRateById } =
		useMutation({
			mutationFn: MinimumWageRateService.archiveMinimumWageRate,
			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the MinimumWageRate fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				formMethods.reset();
				let path = `/minimum-wage-rate`;
				navigate(path);
				return queryClient.invalidateQueries({
					queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
				});
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const archiveMinimumWageRateField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				minimumWageRateId: minimumWageRateId,
				navigateToLogout: navigateToLogout,
			};
			archiveMinimumWageRateById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setMinimumWageRateId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/minimum-wage-rate`;
		navigate(path);
	};

	const expandedLabels = ["Misc.", "Minimum Wage Rate"];
	const expandedMinimumWageRateSetupOrSetupItem = "Minimum Wage Rate"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Misc." &&
				item.label === expandedMinimumWageRateSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedMinimumWageRateSetupOrSetupItem && "/minimum-wage-rate",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		minWageRate: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IMinimumWageRate | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/minimum-wage-rate/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingById ||
					isDeleting ||
					isArchive ||
					provinceDDLLoading
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteMinimumWageRateField}
				cancelActionHandler={onCloseHandler}
				testId="minimumWageRate-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="MinimumWageRate"
										testId={`minimumWageRate`}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<MinimumWageRateInfoSetupFieldsPanel
											countryList={countryList && countryList}
											formMethods={formMethods}
											provinceDDLLoading={(value: boolean) =>
												setProvinceDDLLoading(value)
											}
											// provinceStateLabelinUpdate={
											// 	provinceStateLabelinUpdate && provinceStateLabelinUpdate
											// }
											// provinceStateDDLinUpdate={
											// 	provinceStateDDLinUpdate && provinceStateDDLinUpdate
											// }
											provinceDDLItems={(value: any) =>
												setProvinceDDLItems(value)
											}
										/>
									</StandardPanel>
								}
								toolbar={
									<MinimumWageRateSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								toolbarPosition="bottom"
								showFullDiaplay={true}
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									minimumWageRateList && upadtedMinimumWageRateListItems
										? upadtedMinimumWageRateListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Date" },
									{ field: "province", headerName: "Province" },
									{ field: "minWageRate", headerName: "Rate" },
									{ field: "type", headerName: "Type" },
								]}
								showHeaderColumns={true}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									minimumWageRateList && minimumWageRateList.total
										? minimumWageRateList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				// showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveMinimumWageRateField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"minimumWageRate-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
